// extracted by mini-css-extract-plugin
export default {"wrapper":"UiDrawer_wrapper","right":"UiDrawer_right","close":"UiDrawer_close","open":"UiDrawer_open","touch":"UiDrawer_touch"};